import Alert from 'assets/logos/Alert.svg';
import Arrow from 'assets/logos/Arrow.svg';
import Bank from 'assets/logos/Bank.svg';
import Call from 'assets/logos/Call.svg';
import Cancel from 'assets/logos/Cancel.svg';
import Caution from 'assets/logos/Caution.svg';
import Document from 'assets/logos/Document.svg';
import Hamburger from 'assets/logos/Hamburger.svg';
import Help from 'assets/logos/Help.svg';
import Home from 'assets/logos/Home.svg';
import List from 'assets/logos/List.svg';
import Minus from 'assets/logos/Minus.svg';
import PdfFile from 'assets/logos/PdfFile.svg';
import People from 'assets/logos/People.svg';
import Plus from 'assets/logos/Plus.svg';
import Repeat from 'assets/logos/Repeat.svg';
import Search from 'assets/logos/Search.svg';
import Setting from 'assets/logos/Setting.svg';
import SignOut from 'assets/logos/SignOut.svg';
import EyeOn from 'assets/logos/EyeOn.svg';
import EyeOff from 'assets/logos/EyeOff.svg';
import AuroraBox from 'assets/logos/auroraBox.svg';
import ChartLine from 'assets/logos/chart-line-solid-full.svg';
import Keyboad from 'assets/logos/keyboard-solid-full.svg';
import Key from 'assets/logos/key-solid-full.svg';
import Trash from 'assets/logos/trash-solid-full.svg';

export enum IconName {
  Alert,
  Arrow,
  Bank,
  Call,
  Cancel,
  Caution,
  Document,
  Hamburger,
  Help,
  Home,
  List,
  Minus,
  PdfFile,
  People,
  Plus,
  Repeat,
  Search,
  Setting,
  SignOut,
  EyeOn,
  EyeOff,
  AuroraBox,
  ChartLine,
  Keyboad,
  Key,
  Trash,
}

type Icon = { id: IconName; icon: string };
const Icons: Icon[] = [
  { id: IconName.Alert, icon: Alert },
  { id: IconName.Arrow, icon: Arrow },
  { id: IconName.Bank, icon: Bank },
  { id: IconName.Call, icon: Call },
  { id: IconName.Cancel, icon: Cancel },
  { id: IconName.Caution, icon: Caution },
  { id: IconName.Document, icon: Document },
  { id: IconName.Hamburger, icon: Hamburger },
  { id: IconName.Help, icon: Help },
  { id: IconName.Home, icon: Home },
  { id: IconName.List, icon: List },
  { id: IconName.Minus, icon: Minus },
  { id: IconName.PdfFile, icon: PdfFile },
  { id: IconName.People, icon: People },
  { id: IconName.Plus, icon: Plus },
  { id: IconName.Repeat, icon: Repeat },
  { id: IconName.Search, icon: Search },
  { id: IconName.Setting, icon: Setting },
  { id: IconName.SignOut, icon: SignOut },
  { id: IconName.EyeOn, icon: EyeOn },
  { id: IconName.EyeOff, icon: EyeOff },
  { id: IconName.AuroraBox, icon: AuroraBox },
  { id: IconName.ChartLine, icon: ChartLine },
  { id: IconName.Keyboad, icon: Keyboad },
  { id: IconName.Key, icon: Key },
  { id: IconName.Trash, icon: Trash },
];

export const findIcon = (name: IconName) => {
  return Icons.find((icon) => icon.id === name)?.icon || '';
};
